import cn from '@core/utils/class-names';

interface FormGroupProps {
  title: React.ReactNode;
  className?: string;
  description?: string;
  children?: React.ReactNode;
}

// The Marketplace admin portal's form section (2026-09-28, the project owner's reference for every
// back-office form): the title and description stacked ABOVE the fields, and the fields in a grid of
// one column on a phone, two on a tablet and four on a wide form — where the template put the title
// in a left-hand third beside a two-column grid. A `col-span-full` field still takes the whole row,
// and so does any rizzui `Alert` (an error surface, a caveat banner) or empty state placed among the
// fields — a message squeezed into one field's cell would be unreadable.
// Non-mechanical edit; the props are unchanged, so no caller changed.
export default function FormGroup({
  title,
  className,
  description,
  children,
}: FormGroupProps) {
  return (
    <div className={cn('flex flex-col gap-4', className)}>
      <div>
        <h4 className="text-base font-medium">{title}</h4>
        {description && (
          <p className="mt-1 text-sm text-gray-500">{description}</p>
        )}
      </div>
      {children && (
        <div className="grid grid-cols-1 gap-4 @xl:grid-cols-2 @5xl:grid-cols-4 [&>.rizzui-alert-root]:col-span-full [&>[data-slot=empty-state]]:col-span-full">
          {children}
        </div>
      )}
    </div>
  );
}
